import { Link } from 'react-router';
import type { ReactNode } from 'react';

const POINTS = [
  'Gjesteliste og RSVP er gratis, uten tidsbegrensning',
  'Hver gjest får sin egen svarlenke – ingen konto for dem',
  'Personopplysninger lagres kryptert',
  'Last ned eller slett alt dere har lagt inn, når som helst',
];

export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="auth-page">
      <aside className="auth-aside">
        <Link className="brand" to="/" style={{ color: '#fff', marginBottom: '2rem' }}>
          <span
            className="brand-mark"
            style={{ background: '#fff', color: 'var(--primary)' }}
            aria-hidden="true"
          >
            VD
          </span>
          Vår Dag
        </Link>
        <h2>Planlegging gjort enkelt</h2>
        <p>Alt om dagen deres på ett sted, fra første gjest til siste bordkort.</p>
        <ul>
          {POINTS.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      </aside>

      <div className="auth-form-wrap">
        <div className="auth-form">
          <h1 style={{ fontSize: '1.9rem' }}>{title}</h1>
          {subtitle ? <p className="muted">{subtitle}</p> : null}
          {children}
        </div>
      </div>
    </div>
  );
}
